import { track } from "./telemetry";
import { currentPeriodKey, type UsageResponseEnvelope } from "./usage";

/** Credits left this period after a successful call; null when the server omitted usage. */
export function creditsRemaining(envelope: UsageResponseEnvelope | undefined): number | null {
  if (!envelope) return null;
  return Math.max(0, envelope.includedQuota - envelope.countAfter);
}

/** Callable failures that mean "couldn't reach / finish", not a server bug. */
export function isNetworkCallableError(err: unknown): boolean {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  const code = (err as { code?: unknown } | null)?.code;
  return (
    code === "functions/unavailable" ||
    code === "functions/deadline-exceeded" ||
    code === "unavailable" ||
    code === "deadline-exceeded"
  );
}

const QUOTA_KEY_PREFIX = "room-canvas:ai-quota-reached:";

/** Fire `ai_quota_reached` at most once per UTC month on this device. */
export function noteQuotaReached(plan: "free" | "premium", now = new Date()): void {
  const key = QUOTA_KEY_PREFIX + currentPeriodKey(now);
  try {
    if (window.localStorage.getItem(key)) return;
    window.localStorage.setItem(key, "1");
  } catch {
    // storage unavailable: still count it; a duplicate beats a miss
  }
  track("ai_quota_reached", { plan });
}

/** A successful call that spent the last included credit also reaches the cap. */
export function noteUsageEnvelope(envelope: UsageResponseEnvelope | undefined): void {
  if (!envelope || envelope.plan !== "free") return;
  if (envelope.countAfter >= envelope.includedQuota) noteQuotaReached("free");
}
